module.exports = __webpack_public_path__ + "static/media/delay-saving-tom.193d382b.webp";